export const isCached = false;
export const verbose = false;
export const refresh = true;
export const GetHurricaneUriPath = '/api/hurricanes/v1';
export const getLegendUriPath = '/giv/presentation/legenddata';

export const baseHurricaneWidgetSpotlightIconPath = '/images/hurricane/widget/spotlight_ic_';
export const baseHurricaneWidgetSpotlightIconExtension = '.png';
export const baseSelectedHurricaneDetailIconPath = '/images/hurricane/details/ic_detail_';
export const baseSelectedPastHurricaneDetailIconSubPath = 'past_';

export const HurricaneTropicalStormType = 'TS';
export const HurricaneTropicalDepressionType = 'TD';
export const defaultHurricaneDetailInfo = '--';

export const HurricaneOutlookSummaryIconColours = {
    inactiveStateWhite: '#AEAEB2',
    activeStateYellow: '#FAC52F'
} as const;

export const HurricaneInfoPanelKeyTuple = ['activeHurricane', 'hurricaneOutlook'] as const;
export const HurricaneLegendUnitSystem = {
    english: 'English',
    metric: 'Metric'
} as const;

export const HurricaneTrackPointIconData = {
    width: 22,
    height: 22,
    colour: '#888888'
} as const;
